import { CaseFileModelContext } from './CaseFileModelContext';
import { useContext } from 'react';

export const useCaseFileModelContext = () => {
    const context = useContext(CaseFileModelContext);
    if (!context) {
        throw new Error('useCaseFileModelContext must be used within a CaseFileModelProvider');
    }
    return context;
};